export default __webpack_public_path__ + "static/media/bit_status.311d0185.svg";